import React, { useEffect, useState } from "react";
import { fetchUserDetail } from "../api/fetchUserDetails";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import "./Home.css";
import ModalComponent from "../components/Modal.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrioritiesModal from "../components/PrioritiesModal.js";
import EditPrioritiesModal from "../components/EditPrioritiesModal.js";
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import DeleteUserModel from "../components/DeleteUserModel";
import EditModel from "../components/EditModel";

export default function Home() {
  const [userDetails, setUserDetails] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [openEditModel, setOpenEditModel] = useState(false);
  const [openPrioritiesModal, setOpenPrioritiesModal] = useState(false);
  const [selectedUserIndex, setSelectedUserIndex] = useState(null);
  const [openEditPriorties, setOpenEditPriorties] = useState(false)
  const [deleteUser, setDeleteUser] = useState(false)
  const [userData, setUserData] = useState("")
  const [editDetials, setEditDetails] = useState("")
  const ITEMS_PER_PAGE = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const items = userDetails.slice(indexOfFirstItem, indexOfLastItem);
  const [currentItems, setCurrentItems] = useState(items);
  const totalPages = Math.ceil(userDetails.length / ITEMS_PER_PAGE);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    setCurrentItems(userDetails.slice(indexOfFirstItem, indexOfLastItem));
  }, [currentPage, userDetails]);


  useEffect(() => {
    fetchData();
  }, [openPopup, openPrioritiesModal, openEditPriorties, deleteUser, openEditModel]);


  const handlePopup = (index) => {
    setOpenPopup(true);
    setSelectedUserIndex(index);
  };

  const handleEditPopup = (user) => {
    setOpenEditModel(true);
    setUserData(user);
  };


  const handleClosePopup = () => {
    setOpenPopup(false);
    setSelectedUserIndex(null);
  };

  const OpenPrioritiesPopup = (index) => {
    setOpenPrioritiesModal(true);
    setSelectedUserIndex(index);
  };
  const handleClosePrioritiesModal = () => {
    setOpenPrioritiesModal(false);
    setSelectedUserIndex(null);
  };

  const OpenEditPriorties = (details) => {
    setOpenEditPriorties(true);
    setEditDetails(details)
  };
  const handleCloseEditPriorities = () => {
    setOpenEditPriorties(false);
    setEditDetails('');
  };

  const fetchData = async () => {
    try {
      const data = await fetchUserDetail();
      if (data) {
        setUserDetails(data);
      }
    } catch (error) {
      console.error("Error setting user details:", error);
    }
  };


  const handleDeleteUser = (user) => {
    setDeleteUser(true)
    setUserData(user)
  }



  return (
    <>
      <ToastContainer />
      <div className="header-container">
        <Header />
      </div>
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="col-div">
              <p className="heading-blue fs-2 text-center mt-3">
                hobbyDB Shopify Dashboard
              </p>
              {currentItems && currentItems.length > 0 && (
                <nav style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <div>
                    <ul className="pagination justify-content-center">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button onClick={() => paginate(currentPage - 1)} className="page-link">
                          <BsChevronLeft />
                        </button>
                      </li>
                      <li className="page mx-sm-1 my-sm-1 mx-lg-2 my-lg-2">
                        <p>Page {currentPage} of {totalPages}</p>
                      </li>
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button onClick={() => paginate(currentPage + 1)} className="page-link">
                          <BsChevronRight />
                        </button>
                      </li>
                    </ul>
                  </div>
                </nav>
              )}
            </div>
            <div className="show-data table-scrool">
              <table className="table table-striped table-design">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">FirstName</th>
                    <th scope="col">LastName</th>
                    <th scope="col">Email</th>
                    <th scope="col">Shop Name</th>
                    <th scope="col">Shop URL</th>
                    <th scope="col">Status</th>
                    <th scope="col">Priority</th>
                    <th scope="col">User ID</th>
                    <th scope="col">Catalog Item Type ID</th>
                    <th scope="col">Direct Link Logo ID</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems && currentItems.length > 0 ? (
                    currentItems.map((user, index) => (
                      <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        <td>{user.firstName}</td>
                        <td>{user.lastName}</td>
                        <td>{user.email}</td>
                        <td>{user.shopName}</td>
                        <td style={{ minWidth: "200px" }}>
                          <Link to={user.shopUrl} target="_blank">
                            {user.shopUrl}
                          </Link>
                        </td>
                        <td>{user.status}</td>
                        <td>{user.priorities ? user.priorities : "-"}</td>
                        <td>{user.userId ? user.userId : "-"}</td>
                        <td>{user.catalogItemId ? user.catalogItemId : "-"}</td>
                        <td>{user.directLinkId ? user.directLinkId : "-"}</td>
                        <td style={{ minWidth: "125px" }}>
                          <div className="btns">
                            <div className="btns-div1">
                              {!user.priorities ? <button
                                className="custom-button btn btn-primary"
                                style={{ padding: "6px 6px" }}
                                onClick={() => OpenPrioritiesPopup(index)}
                              >
                                Add Priority
                              </button> : <button
                                className="custom-button btn btn-primary"
                                onClick={() => OpenEditPriorties(user)}
                                style={{ padding: "6px 6px" }}
                              >
                                Edit Priority
                              </button>}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="btns">
                            <div className="btns-div2">
                              {user.status === "pending" ? <button
                                className="custom-button btn btn-primary btn-rounded"
                                onClick={() => handlePopup(index)}
                                disabled={user.status === "approved" || !user.priorities}
                                style={{
                                  backgroundColor:
                                    user.status === "approved" ? "gray" : "blue",
                                  borderColor:
                                    user.status === "approved" ? "gray" : "blue",
                                  cursor:
                                    user.status === "approved"
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                              >
                                {user.status === "approved"
                                  ? "Approved"
                                  : "Approve"}
                              </button>
                                :
                                <button type="submit" disabled={user.status === "pending"} style={{ backgroundColor: "#043174", color: "white", borderRadius: '5px' }} onClick={() => handleEditPopup(user)}>Edit</button>}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="btns">
                            <button type="submit" className="btn-rounded" style={{ backgroundColor: '#a10202', color: '#fff', borderRadius: '5px' }} onClick={() => handleDeleteUser(user)}>Delete</button>
                          </div>
                        </td>
                        {/* <td className="btns">
                          {!user.priorities ? (
                            <button
                              className="custom-button"
                              onClick={() => OpenPrioritiesPopup(index)}
                            >
                              Add Priorities
                            </button>
                          ) : (
                            <button
                              className="custom-button"
                              onClick={() => OpenEditPriorties(user)}
                            >
                              Edit Priorities
                            </button>
                          )}  

                          <button
                            className="custom-button"
                            onClick={() => handlePopup(index)}
                            disabled={
                              user.status === "approved" || !user.priorities
                            }
                            style={{
                              backgroundColor:
                                user.status === "approved" ? "gray" : "blue",
                              borderColor:
                                user.status === "approved" ? "gray" : "blue",
                              cursor:
                                user.status === "approved"
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            {user.status === "approved"
                              ? "Approved"
                              : "Approve"}
                          </button>
                        </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="13" className="text-center">
                        No User Details
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {openPopup && (
              <ModalComponent
                openPopup={openPopup}
                handleClosePopup={handleClosePopup}
                userDetails={currentItems[selectedUserIndex]}
              />
            )}
            {openEditModel && (
              <EditModel
                openPopup={openEditModel}
                setOpenEditModel={setOpenEditModel}
                userDetails={userData}
              />
            )}

            {openPrioritiesModal && (
              <PrioritiesModal
                openPrioritiesModal={openPrioritiesModal}
                handleClosePrioritiesModal={handleClosePrioritiesModal}
                userDetails={currentItems[selectedUserIndex]}
              />
            )}

            {openEditPriorties && (
              <EditPrioritiesModal
                openEditPriorties={openEditPriorties}
                handleCloseEditPriorities={handleCloseEditPriorities}
                editDetials={editDetials} />
            )}

            {deleteUser && (<DeleteUserModel openDeleteUser={deleteUser} setDeleteUser={setDeleteUser} userData={userData} setUserDetails={setUserDetails} />)}
          </div>
        </div>
      </div >
      <div className="footer-container"></div>
    </>
  );
}
